module.exports = __webpack_public_path__ + "static/img/repair1.56b145e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/repair1.gif
// module id = Lb1n
// module chunks = 0